import { observer } from 'mobx-react-lite';

import { FC } from 'react';

export const SupportMessages: FC = observer(() => {
    return (
        <div className="support-messages-wrap">
            <div className="messages-content">
                <div className="messages-content-inner">
                    <div className="messages-date">June 04, 2024</div>
                    <div className="messages-list">
                        <div className="messages-item">
                            <div className="messages-item-content">
                                <div className="message-avatar">
                                    <figure>
                                        <img src="/assets/img/message-avatar.svg" />
                                    </figure>
                                </div>
                                <div className="message-text-wrap">
                                    <div className="message-text">Hi, how can I help You?</div>
                                </div>
                            </div>
                            <div className="messages-item-time">7:37 PM</div>
                        </div>
                        <div className="messages-answer">
                            <div className="answer-text-wrap">
                                <div className="answer-text">I didn't receive my Unity Points</div>
                            </div>
                        </div>
                        <div className="messages-item">
                            <div className="messages-item-content">
                                <div className="message-avatar">
                                    <figure>
                                        <img src="/assets/img/message-avatar.svg" />
                                    </figure>
                                </div>
                                <div className="message-text-wrap">
                                    <div className="message-text">Ooops...</div>
                                </div>
                            </div>
                            <div className="messages-item-time">7:40 PM</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="messages-send-wrap">
                <div className="messages-send">
                    <input className="form-control" name="message" type="text" placeholder="Ask something" />
                    <button type="button" className="btn">
                        <figure>
                            <img src="/assets/img/msg-btn.svg" />
                        </figure>
                    </button>
                </div>
            </div>
        </div>
    );
});
